import { styled } from '@compiled/react';

import { N80, N20 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SortByLabel = styled.span({
	color: token('color.text.subtlest', N80),
	fontWeight: 500,
	fontSize: '12px',
	lineHeight: '24px',
	marginRight: token('space.050', '4px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SortByDropdownWrapper = styled.div({
	display: 'flex',
	alignItems: 'baseline',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DropdownWrapper = styled.div({
	width: '200px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SortByDropdownLoading = styled.span({
	width: '200px',
	backgroundColor: token('color.skeleton', N20),
	height: '32px',
	borderRadius: '3px',
});
